module.exports = __webpack_public_path__ + "static/media/dm.d41090a0.png";